import { render, staticRenderFns } from "./insurance_invoices.vue?vue&type=template&id=7effcc2a&"
import script from "./insurance_invoices.vue?vue&type=script&lang=js&"
export * from "./insurance_invoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports